import { defineStore } from 'pinia';

export const useModalStore = defineStore('modal', {
  state: () => ({
    modal: {
      type: null as 'auth' | 'confirm' | 'loader' | null,
      props: {} as Record<string, unknown>,
    },
  }),
  actions: {
    open(type: 'auth' | 'confirm' | 'loader', props = {}) {
      this.modal = { type, props };
    },
    setPropField(name: string, value: unknown) {
      this.modal.props[name] = value;
    },
    close(timeout: number = 0) {
      if (timeout <= 0) {
        this.modal = { type: null, props: {} };
        return;
      }

      setTimeout((modalStore) => {
        modalStore.modal = { type: null, props: {} };
      }, timeout, this);
    },
  },
});
